export default function ($routeSegmentProvider) {

  "ngInject";

  $routeSegmentProvider
    .when('/service-provider/settings/work-areas', 'service-provider.work-areas')
    .when('/service-provider/settings/bicycle-shops', 'service-provider.bicycle-shops')
    .when('/service-provider/settings/pick-up-and-drop-off', 'service-provider.pick-up-and-drop-off')
    .when('/service-provider/settings/schedule', 'service-provider.schedule')
    .when('/service-provider/settings/expertise', 'service-provider.expertise')
    .when('/service-provider/settings/parts', 'service-provider.parts')
    .when('/service-provider/settings/applications', 'service-provider.applications')
    .when('/service-provider/settings/security', 'service-provider.security')

    .within('service-provider')

    .segment('work-areas', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: 'service_provider.breadcrumb.settings'
      }],
      template: '<service-provider-work-areas-page></service-provider-work-areas-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-work-areas.module" */ "./work-areas/service-provider-work-areas.module");
      }
    })

    .segment('bicycle-shops', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: 'service_provider.breadcrumb.settings'
      }],
      template: '<service-provider-bicycle-shops-page></service-provider-bicycle-shops-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-bicycle-shops.module" */ "./bicycle-shops/service-provider-bicycle-shops.module");
      }
    })

    .segment('pick-up-and-drop-off', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: 'service_provider.breadcrumb.settings'
      }],
      template: '<service-provider-pick-up-and-drop-off-page></service-provider-pick-up-and-drop-off-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-pick-up-and-drop-off.module" */ "./pick-up-and-drop-off/service-provider-pick-up-and-drop-off.module");
      }
    })

    .segment('schedule', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: 'service_provider.breadcrumb.settings'
      }],
      template: '<service-provider-schedule-page></service-provider-schedule-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-schedule.module" */ "./schedule/service-provider-schedule.module");
      }
    })

    .segment('expertise', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: 'service_provider.breadcrumb.settings'
      }],
      template: '<service-provider-expertise-page></service-provider-expertise-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-expertise.module" */ "./expertise/service-provider-expertise.module");
      }
    })

    .segment('parts', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: 'service_provider.breadcrumb.settings'
      }],
      template: '<service-provider-perts-page></service-provider-perts-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-parts.module" */ "./parts/service-provider-parts.module");
      }
    })

    .segment('applications', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: 'service_provider.breadcrumb.settings'
      }],
      template: '<service-provider-installed-applications-page></service-provider-installed-applications-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-applications.module" */ "./applications/service-provider-applications.module");
      }
    })

    .segment('security', {
      access: {requireLogin: true, hasAuthority: 'MECHANIC'},
      breadcrumb: [{
        label: 'service_provider.breadcrumb.settings'
      }],
      template: '<service-provider-security-page></service-provider-security-page>',
      loadModule: () => {
        return import(/* webpackChunkName: "service-provider-security.module" */ "./security/service-provider-security.module");
      }
    });
}
